module.exports = __webpack_public_path__ + "img/5444.2d2b1201.jpg";